/* Bikers Wear — instant search in the header (26-9-2026).
   As you type: suggested searches + products (Shopify predictive search, typo tolerant) + sports/ranges matched
   on this device with typo tolerance. Empty box: recent searches, popular searches, top ranges. Full keyboard support. */
(function () {
  'use strict';
  var form = document.querySelector('[data-ess-form]');
  var input = form && form.querySelector('input[name="q"]');
  var box = document.getElementById('esh-ps');
  if (!form || !input || !box) return;
  function $(s) { return box.querySelector(s); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var cols = [];
  try { cols = JSON.parse(document.querySelector('[data-ess-cols]').textContent); } catch (e) {}
  var idle = $('[data-ps-idle]'), live = $('[data-ps-live]');
  var sugg = $('[data-ps-sugg]'), colsEl = $('[data-ps-cols]'), prods = $('[data-ps-prods]'), all = $('[data-ps-all]'), status = $('[data-ps-status]');
  var searchUrl = form.getAttribute('action');
  var timer = null, ctrl = null, active = -1, lastQ = null;

  /* ---------- recent searches (this device only) ---------- */
  var KEY = 'esh-recent-searches';
  function recent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function remember(q) {
    q = q.trim(); if (!q) return;
    try { var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 5))); } catch (e) {}
  }
  function renderRecent() {
    var wrap = $('[data-ps-recent]'); if (!wrap) return;
    var r = recent();
    wrap.hidden = !r.length;
    $('[data-ps-recent-list]').innerHTML = r.map(function (q) {
      return '<li><a role="option" class="ess-chip" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product" data-q="' + esc(q) + '">' + esc(q) + '</a></li>';
    }).join('');
  }
  var clr = $('[data-ps-recent-clear]');
  if (clr) clr.addEventListener('click', function () { try { localStorage.removeItem(KEY); } catch (e) {} renderRecent(); input.focus(); });

  /* ---------- typo-tolerant range matching ---------- */
  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) d[i] = [i];
    for (j = 1; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[a.length][b.length];
  }
  function words(s) { return s.toLowerCase().replace(/&/g, ' ').split(/[^a-z0-9]+/).filter(function (w) { return w.length > 1; }); }
  function matchCols(q) {
    var qw = words(q).filter(function (w) { return w.length >= 3; });
    if (!qw.length) return [];
    return cols.map(function (c) {
      var tw = words(c.t), score = 0;
      qw.forEach(function (w) {
        var best = 0;
        tw.forEach(function (t) {
          if (t === w) best = Math.max(best, 3);
          else if (t.indexOf(w) === 0 || (w.length >= 4 && w.indexOf(t) === 0 && t.length >= 4)) best = Math.max(best, 2);
          else if (w.length >= 4 && lev(w, t) <= (w.length >= 7 ? 2 : 1)) best = Math.max(best, 1.5);
        });
        score += best;
      });
      return { c: c, s: score };
    }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s || b.c.n - a.c.n; }).slice(0, 4).map(function (x) { return x.c; });
  }
  function colHtml(c) {
    return '<li><a role="option" class="ess-ps__c" href="' + esc(c.u) + '"><span class="ess-ps__cimg">' + (c.i ? '<img src="' + esc(c.i) + '" alt="" width="40" height="40" loading="lazy">' : '') + '</span><span><strong>' + esc(c.t) + '</strong><small>' + c.n + ' products</small></span></a></li>';
  }

  /* ---------- open / close ---------- */
  function open() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
  function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); setActive(-1); }
  function options() { return Array.prototype.slice.call(box.querySelectorAll('[role="option"]')).filter(function (o) { return o.offsetParent !== null; }); }
  function setActive(i) {
    var o = options();
    o.forEach(function (x, k) { x.classList.toggle('is-active', k === i); x.setAttribute('aria-selected', k === i ? 'true' : 'false'); if (!x.id) x.id = 'ess-o-' + k + '-' + Math.random().toString(36).slice(2, 6); });
    active = i;
    if (i > -1 && o[i]) { input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({ block: 'nearest' }); } else input.removeAttribute('aria-activedescendant');
  }

  function showIdle() { renderRecent(); idle.hidden = false; live.hidden = true; open(); setActive(-1); }

  function run(q) {
    if (q === lastQ) { open(); return; }
    lastQ = q;
    idle.hidden = true; live.hidden = false; open();
    all.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
    all.innerHTML = 'See all results for <strong>“' + esc(q) + '”</strong> →';
    var local = matchCols(q);
    colsEl.innerHTML = local.map(colHtml).join('');
    colsEl.parentNode.hidden = !local.length;
    box.classList.add('is-loading');
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var u = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'search/suggest?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=esh-predictive';
    fetch(u, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (h) {
      if (q !== lastQ) return;
      box.classList.remove('is-loading');
      var d = new DOMParser().parseFromString(h, 'text/html');
      var qs = d.querySelector('[data-ps-queries]'), pl = d.querySelector('[data-ps-products]'), sc = d.querySelectorAll('[data-ps-collections] li');
      sugg.innerHTML = qs ? qs.innerHTML : '';
      sugg.parentNode.hidden = !qs;
      // merge Shopify's collection matches with ours (no duplicates)
      var seen = {}; local.forEach(function (c) { seen[c.u] = 1; });
      var extra = Array.prototype.slice.call(sc).map(function (li) { return { u: li.getAttribute('data-url'), t: li.getAttribute('data-title'), n: +li.getAttribute('data-count'), i: li.getAttribute('data-img') }; }).filter(function (c) { return !seen[c.u] && c.n > 0; });
      var merged = local.concat(extra).slice(0, 4);
      colsEl.innerHTML = merged.map(colHtml).join('');
      colsEl.parentNode.hidden = !merged.length;
      var n = pl ? pl.children.length : 0;
      prods.innerHTML = n ? pl.innerHTML : '<li class="ess-ps__none">No products match “' + esc(q) + '” yet — try a shorter word or pick a range.</li>';
      all.hidden = !n;
      status.textContent = n ? n + ' products shown. Use the arrow keys to move through the results.' : 'No products found.';
      setActive(-1);
    }).catch(function () { box.classList.remove('is-loading'); });
  }

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-controls', 'esh-ps');
  input.setAttribute('aria-expanded', 'false');

  input.addEventListener('focus', function () { var q = input.value.trim(); if (q.length >= 2) run(q); else showIdle(); });
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { lastQ = null; showIdle(); return; }
    timer = setTimeout(function () { run(q); }, 160);
  });
  input.addEventListener('keydown', function (e) {
    var o = options();
    if (e.key === 'ArrowDown') { e.preventDefault(); if (box.hidden) { input.dispatchEvent(new Event('focus')); return; } setActive(Math.min(active + 1, o.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
    else if (e.key === 'Enter' && active > -1 && o[active]) { e.preventDefault(); var q = o[active].getAttribute('data-q'); remember(q || input.value); window.location.href = o[active].href; }
    else if (e.key === 'Escape') { close(); }
  });
  form.addEventListener('submit', function () { remember(input.value); });
  box.addEventListener('click', function (e) {
    var a = e.target.closest('a[role="option"]');
    if (a) remember(a.getAttribute('data-q') || input.value);
  });
  document.addEventListener('click', function (e) { if (!box.hidden && !box.contains(e.target) && !form.contains(e.target)) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
})();